import { useEffect, useState } from "react";
import api from "@/lib/api";
import { StatusPill } from "./DashboardLayout";
import { Link } from "react-router-dom";

export default function AdminOverview() {
  const [stats, setStats] = useState({ pending_license: 0, pending_id: 0, doctors: 0, orders: 0, products: 0, categories: 0 });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/licenses?status=pending").then((r) => r.data),
      api.get("/identity?status=pending").then((r) => r.data),
      api.get("/admin/users?role=doctor").then((r) => r.data),
      api.get("/orders").then((r) => r.data),
      api.get("/products").then((r) => r.data),
      api.get("/categories").then((r) => r.data),
    ]).then(([lic, ids, docs, orders, prods, cats]) => {
      setStats({
        pending_license: lic.length,
        pending_id: ids.length,
        doctors: docs.length,
        orders: orders.length,
        products: prods.length,
        categories: cats.length,
      });
      setRecent(orders.slice(0, 6));
    });
  }, []);

  return (
    <div className="space-y-10">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {[
          { k: stats.pending_id, l: "pending ID", to: "/dashboard/verifications" },
          { k: stats.pending_license, l: "pending license", to: "/dashboard/verifications" },
          { k: stats.doctors, l: "doctors", to: "/dashboard/users" },
          { k: stats.orders, l: "orders", to: "/dashboard/orders" },
          { k: stats.products, l: "products", to: "/dashboard/products" },
          { k: stats.categories, l: "categories", to: "/dashboard/categories" },
        ].map((s) => {
          const Inner = (
            <>
              <div className="font-display text-3xl font-bold">{s.k}</div>
              <div className="overline mt-1">{s.l}</div>
            </>
          );
          return s.to ? (
            <Link key={s.l} to={s.to} className="border border-border bg-white p-5 lift" data-testid={`overview-${s.l.replace(/\s+/g, "-")}`}>{Inner}</Link>
          ) : (
            <div key={s.l} className="border border-border bg-white p-5">{Inner}</div>
          );
        })}
      </div>

      <div>
        <div className="overline mb-3">Recent orders</div>
        {recent.length === 0 ? (
          <div className="border border-border bg-white p-6 text-sm text-muted-foreground">No orders yet.</div>
        ) : (
          <div className="border border-border bg-white divide-y divide-border">
            {recent.map((o) => (
              <div key={o.order_id} className="p-4 grid grid-cols-1 md:grid-cols-12 items-start md:items-center gap-2 md:gap-3">
                <div className="md:col-span-3 font-mono text-xs text-muted-foreground">{o.order_id}</div>
                <div className="md:col-span-4 text-sm">
                  <div>{o.user_email}</div>
                  <div className="text-xs text-muted-foreground">{o.user_role}</div>
                </div>
                <div className="md:col-span-3 font-mono text-sm">${o.total.toFixed(2)}</div>
                <div className="md:col-span-2 md:text-right"><StatusPill status={o.status} /></div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
